/**
 *
 * @Author: Martin Yin
 * @Date: 2019-12-04 15:14:31
 * @Last Modified by: Martin Yin
 * @Last Modified time: 2020-06-23 18:30:24
 * @说明
 * 该文件处理错误提示中的前缀文案，根据所有url返回对应的文案，再拼接具体错误原因，或者错误码
 * @注意
 * 1、新增url对应文案的时候需要注意是否区分请求方法例如 post 与 get，如果区分需要加入 method 字段
 * 2、新增完成后一定使用 svn中code同级的doc目录下的test目录中的 url-tip-constant文件夹中的代码进行单元测试。
 *    在项目总入口 import 'test.js' 并且需要testData.js测试数据集，新增的url正则后同时需要将测试数据新增到testData.js。
 */

import i18n from '@pro/common/i18n/i18n';
export const URL_TIP_MAP = {
  deviceaccess: [
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/batchadd$/,
      index: 1
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/add$/,
      index: 2
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/[^/]+\/update$/,
      index: 3
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/delete$/,
      index: 5
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/search$/,
      index: 6
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/triggertypecap$/,
      index: 7
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/triggereventcap$/,
      index: 8
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/actiontypecap$/,
      index: 9
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/actioncap$/,
      index: 10
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/capabilitydevlist$/,
      index: 11
    },
    {
      re: /^deviceaccess\/[^/]+\/PTZ\/presets$/,
      index: 12
    },
    {
      re: /^deviceaccess\/[^/]+\/PTZ\/patrols$/,
      index: 13
    },
    {
      re: /^deviceaccess\/[^/]+\/PTZ\/pattern$/,
      index: 14
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/refresh$/,
      index: 16
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/company\/refresh$/,
      index: 17
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/[^/]+\/alarmstatus$/,
      index: 18
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/chime\/[^/]+$/,
      method: 'get',
      index: 19
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/chime\/[^/]+$/,
      method: 'post',
      index: 20
    },
    {
      re: /^deviceaccess\/[^/]+\/deviceupgrade\/deviceInfo$/,
      index: 21
    },
    {
      re: /^deviceaccess\/[^/]+\/deviceupgrade\/update$/,
      index: 22
    },
    {
      re: /^deviceaccess\/[^/]+\/deviceupgrade\/progress$/,
      index: 23
    },
    {
      re: /^deviceaccess\/[^/]+\/deviceauth\/enauthtest$/,
      index: 24
    },
    {
      re: /^deviceaccess\/[^/]+\/deviceupgradelan\/upgradepackaddress$/,
      index: 116
    },
    {
      re: /^deviceaccess\/[^/]+\/deviceupgradelan\/detectinfo\/site\/[^/]+$/,
      index: 117
    },
    {
      re: /^deviceaccess\/[^/]+\/deviceupgradelan\/upgraderesult$/,
      index: 118
    },
    {
      re: /^deviceaccess\/[^/]+\/transparent\/[^/]+$/,
      index: 119
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/[^/]+\/defence$/,
      index: 123,
      method: 'get'
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/[^/]+\/defence$/,
      index: 124,
      method: 'post'
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/actioncaplist$/,
      index: 126
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/triggercap$/,
      index: 127
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/templatecap$/,
      index: 128
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/triggerdevlist$/,
      index: 129
    },
    {
      re: /^deviceaccess\/[^/]+\/enablelinkagerule$/,
      index: 130
    },
    {
      re: /^deviceaccess\/[^/]+\/linkagerule\/[^/]+$/,
      index: 4
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/hikddns\/[^/]+$/,
      index: 197
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/hikddnsinfo\/[^/]+$/,
      index: 198
    },
    {
      re: /^deviceaccess\/v1\/cloudstorage\/dvr\/[^/]+\/capabilities$/,
      index: 199
    },
    {
      re: /^deviceaccess\/[^/]+\/cloudstorage\/dvr\/[^/]+\/channels\/[^/]+\/switch$/,
      index: 200
    },
    {
      re: /^deviceaccess\/[^/]+\/cloudstorage\/dvr\/[^/]+\/channellist$/,
      index: 201
    },
    {
      re: /^deviceaccess\/[^/]+\/deviceexport\/qrdata$/,
      index: 202
    },
    {
      re: /^deviceaccess\/[^/]+\/devicecamera\/device\/[^/]+$/,
      index: 203
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/ipdomain\/[^/]+$/,
      index: 204
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/bandwidthdetection$/,
      index: 205
    },
    {
      re: /^deviceaccess\/[^/]+\/devicestatus\/bandwidthresult$/,
      index: 206
    },
    {
      re: /^deviceaccess\/[^/]+\/thermalcamera\/deviceinfo$/,
      index: 220
    },
    {
      re: /^deviceaccess\/[^/]+\/peoplecounting\/groupcontrol$/,
      index: 230
    },
    {
      re: /^deviceaccess\/[^/]+\/cloudstorage\/box\/[^/]+\/channels$/,
      index: 245
    },
    {
      re: /^deviceaccess\/[^/]+\/cloudstorage\/box\/[^/]+\/channellist$/,
      index: 246
    },
    {
      re: /^deviceaccess\/[^/]+\/cloudstorage\/box\/[^/]+\/channels\/[^/]+\/switch$/,
      index: 247
    }
  ],
  company: [
    {
      re: /^company\/[^/]+\/regist\/code\/mail$/,
      index: 25
    },
    {
      re: /^company\/[^/]+\/regist$/,
      index: 26
    },
    {
      re: /^company\/[^/]+\/deregist\/code\/mail$/,
      index: 27
    },
    {
      re: /^company\/[^/]+\/deregist$/,
      index: 28
    },
    {
      re: /^company\/[^/]+\/regist\/information\/complete$/,
      index: 29
    },
    {
      re: /^company\/security\/[^/]+\/account\/login$/,
      index: 30
    },
    {
      re: /^company\/security\/[^/]+\/account\/logout$/,
      index: 31
    },
    {
      re: /^company\/security\/[^/]+\/captcha$/,
      index: 32
    },
    {
      re: /^company\/security\/[^/]+\/password\/reset$/,
      index: 34
    },
    {
      re: /^company\/security\/[^/]+\/password\/reset\/code\/mail$/,
      index: 35
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/add$/,
      index: 36
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/invitation\/mail$/,
      index: 37
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/[^/]+\/update$/,
      index: 39
    },
    {
      re: /^company\/manager\/[^/]+\/installers\/delete$/,
      index: 40
    },
    {
      re: /^company\/manager\/[^/]+\/installers\/list$/,
      index: 41
    },
    {
      re: /^company\/manager\/[^/]+\/installers\/search$/,
      index: 42
    },
    {
      re: /^company\/self\/installer\/[^/]+\/avatar\/upload$/,
      index: 43
    },
    {
      re: /^company\/self\/installer\/[^/]+\/email\/update$/,
      index: 44
    },
    {
      re: /^company\/self\/installer\/[^/]+\/email\/update\/code\/mail$/,
      index: 45
    },
    {
      re: /^company\/self\/installer\/[^/]+\/message\/update$/,
      index: 46
    },
    {
      re: /^company\/self\/installer\/[^/]+\/password\/update$/,
      index: 47
    },
    {
      re: /^company\/[^/]+$/,
      index: 48
    },
    {
      re: /^company\/[^/]+\/capabilit$/,
      index: 49
    },
    {
      re: /^company\/[^/]+\/devices$/,
      index: 50
    },
    {
      re: /^company\/[^/]+\/packages$/,
      index: 51
    },
    {
      re: /^company\/[^/]+\/update$/,
      index: 52
    },
    {
      re: /^company\/[^/]+\/upload\/license$/,
      index: 53
    },
    {
      re: /^company\/[^/]+\/upload\/logo$/,
      index: 54
    },
    {
      re: /^company\/installer\/[^/]+\/role\/add$/,
      index: 55
    },
    {
      re: /^company\/installer\/[^/]+\/role\/[^/]+$/,
      index: 56
    },
    {
      re: /^company\/installer\/[^/]+\/role\/[^/]+\/update$/,
      index: 57
    },
    {
      re: /^company\/installer\/[^/]+\/roles\/delete$/,
      index: 58
    },
    {
      re: /^company\/installer\/[^/]+\/roles\/search$/,
      index: 59
    },
    {
      re: /^company\/payment\/[^/]+\/buy\/goods$/,
      index: 60
    },
    {
      re: /^company\/payment\/[^/]+\/price$/,
      index: 61
    },
    {
      re: /^company\/payment\/[^/]+\/records$/,
      index: 62
    },
    {
      re: /^company\/payment\/[^/]+\/stripe\/key$/,
      index: 63
    },
    {
      re: /^company\/[^/]+\/staffs$/,
      index: 92
    },
    {
      re: /^company\/installer\/[^/]+\/logs\/add$/,
      index: 93
    },
    {
      re: /^company\/installer\/[^/]+\/logs\/installers$/,
      index: 94
    },
    {
      re: /^company\/installer\/[^/]+\/logs\/search$/,
      index: 95
    },
    {
      re: /^company\/feedback\/[^/]+\/add$/,
      index: 98
    },
    {
      re: /^company\/feedback\/[^/]+\/upload$/,
      index: 99
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/invitation\/check$/,
      index: 100
    },
    {
      re: /^company\/[^/]+\/update\/logo\/status$/,
      index: 114
    },
    {
      re: /^company\/home\/[^/]+\/statics$/,
      index: 131
    },
    {
      re: /^company\/home\/[^/]+\/push\/statics$/,
      index: 132
    },
    {
      re: /^company\/home\/[^/]+\/site\/browse\/record$/,
      index: 141
    },
    {
      re: /^company\/payment\/management\/[^/]+\/orders$/,
      index: 154
    },
    {
      re: /^company\/payment\/management\/[^/]+\/orderInfo\/[^/]+$/,
      index: 155
    },
    {
      re: /^company\/self\/installer\/[^/]+\/password\/check$/,
      index: 157
    },
    {
      re: /^company\/self\/installer\/[^/]+\/auth$/,
      index: 158
    },
    {
      re: /^company\/order\/[^/]+\/create\/renewal\/dev\/order$/,
      index: 165
    },
    {
      re: /^company\/order\/[^/]+\/create\/dilatation\/dev\/order$/,
      index: 166
    },
    {
      re: /^company\/order\/[^/]+\/create\/renewal\/staff\/order$/,
      index: 167
    },
    {
      re: /^company\/order\/[^/]+\/create\/dilatation\/staff\/order$/,
      index: 168
    },
    {
      re: /^company\/info\/license\/[^/]+\/use$/,
      index: 170
    },
    {
      re: /^company\/info\/license\/[^/]+\/get$/,
      index: 171
    },
    {
      re: /^company\/payment\/management\/[^/]+\/order\/status\/[^/]+$/,
      index: 176
    },
    {
      re: /^company\/payment\/management\/[^/]+\/pay\/[^/]+$/,
      index: 177
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/enable$/,
      index: 182
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/subscribe$/,
      index: 183
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/unsubscribe$/,
      index: 185
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/getsubscribe$/,
      index: 186
    },
    {
      re: /^company\/package\/[^/]+\/get\/devicelimit$/,
      index: 190
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/count$/,
      index: 195
    },
    {
      re: /^company\/package\/[^/]+\/get\/staff\/package$/,
      index: 191
    },
    {
      re: /^company\/info\/[^/]+\/license\/list$/,
      index: 211
    },
    {
      re: /^company\/info\/[^/]+\/license\/use$/,
      index: 212
    },
    {
      re: /^company\/manager\/[^/]+\/installer\/[^/]+$/,
      index: 38
    },
    {
      re: /^company\/[^/]+\/branch\/examine$/,
      index: 231
    },
    {
      re: /^company\/syscom\/[^/]+\/security\/login$/,
      index: 232
    },
    {
      re: /^company\/syscom\/[^/]+\/installer\/complete$/,
      index: 233
    },
    {
      re: /^company\/syscom\/[^/]+\/company\/get$/,
      index: 234
    },
    {
      re: /^company\/info\/[^/]+\/package\/storage$/,
      index: 237
    },
    {
      re: /^company\/info\/[^/]+\/pay\/package\/storage$/,
      index: 238
    },
    {
      re: /^company\/order\/[^/]+\/create\/cloud\/stage\/order$/,
      index: 239
    }
  ],
  site: [
    {
      re: /^site\/[^/]+\/add$/,
      index: 66
    },
    {
      re: /^site\/[^/]+\/search$/,
      index: 67
    },
    {
      re: /^site\/[^/]+\/assign$/,
      index: 68
    },
    {
      re: /^site\/device\/[^/]+\/delete$/,
      index: 115
    },
    {
      re: /^site\/[^/]+\/[^/]+\/delete$/,
      index: 69
    },
    {
      re: /^site\/[^/]+\/[^/]+\/device\/count\/overview$/,
      index: 71
    },
    {
      re: /^site\/[^/]+\/[^/]+\/update$/,
      index: 72
    },
    {
      re: /^site\/trusteeship\/[^/]+\/invite$/,
      index: 73
    },
    {
      re: /^site\/trusteeship\/[^/]+\/sites\/search$/,
      index: 74
    },
    {
      re: /^site\/trusteeship\/[^/]+\/site\/[^/]+\/apply$/,
      index: 75
    },
    {
      re: /^site\/trusteeship\/[^/]+\/devices\/apply$/,
      index: 76
    },
    {
      re: /^site\/device\/[^/]+\/add$/,
      index: 77
    },
    {
      re: /^site\/device\/[^/]+\/alarmhost\/en\/authentication$/,
      index: 78
    },
    {
      re: /^site\/device\/[^/]+\/alarmhost\/[^/]+\/en\/authentication$/,
      index: 79
    },
    {
      re: /^site\/device\/[^/]+\/device\/category$/,
      index: 80
    },
    {
      re: /^site\/device\/[^/]+\/device\/name$/,
      index: 81
    },
    {
      re: /^site\/device\/[^/]+\/devices\/search$/,
      index: 82
    },
    {
      re: /^site\/camera\/[^/]+\/bydevice\/[^/]+$/,
      index: 83
    },
    {
      re: /^site\/operations\/[^/]+\/sites\/status$/,
      index: 85
    },
    {
      re: /^site\/operations\/[^/]+\/encodedevice\/[^/]+\/status$/,
      index: 86
    },
    {
      re: /^site\/operations\/[^/]+\/devices\/status\/[^/]+\/search$/,
      index: 87
    },
    {
      re: /^site\/operations\/[^/]+\/devices\/status\/search$/,
      index: 88
    },
    {
      re: /^site\/operations\/[^/]+\/devices\/status\/general$/,
      index: 89
    },
    {
      re: /^site\/operations\/[^/]+\/alarmhost\/[^/]+\/status$/,
      index: 90
    },
    {
      re: /^site\/operations\/[^/]+\/alarmhost\/unhealthyinput\/[^/]+\/reason$/,
      index: 91
    },
    {
      re: /^site\/[^/]+\/[^/]+\/noreminders$/,
      index: 96
    },
    {
      re: /^site\/[^/]+\/trusteeship\/count$/,
      index: 97
    },
    {
      re: /^site\/export\/[^/]+\/exception\/event\/search$/,
      index: 101
    },
    {
      re: /^site\/event\/[^/]+\/rule\/search$/,
      index: 102
    },
    {
      re: /^site\/event\/[^/]+\/rule\/detail$/,
      index: 103
    },
    {
      re: /^site\/event\/[^/]+\/rule\/update$/,
      index: 104
    },
    {
      re: /^site\/event\/[^/]+\/rule\/copy$/,
      index: 105
    },
    {
      re: /^site\/event\/[^/]+\/push\/history$/,
      index: 106
    },
    {
      re: /^site\/event\/[^/]+\/push\/logout$/,
      index: 107
    },
    {
      re: /^site\/event\/[^/]+\/push\/real$/,
      index: 108
    },
    {
      re: /^site\/event\/[^/]+\/push\/regist$/,
      index: 109
    },
    {
      re: /^site\/[^/]+\/list$/,
      index: 110
    },
    {
      re: /^site\/camera\/[^/]+\/message$/,
      index: 111
    },
    {
      re: /^site\/operations\/[^/]+\/encodeDevice\/[^/]+\/status$/,
      index: 112
    },
    {
      re: /^site\/[^/]+\/[^/]+\/renew\/mail$/,
      index: 113
    },
    {
      re: /^site\/device\/[^/]+\/subtype\/[^/]+$/,
      index: 133
    },
    {
      re: /^site\/device\/access\/[^/]+\/pin\/apply$/,
      index: 134
    },
    {
      re: /^site\/daylight\/[^/]+\/zoneTime\/[^/]+$/,
      index: 135
    },
    {
      re: /^site\/device\/[^/]+\/account\/set$/,
      index: 136
    },
    {
      re: /^site\/device\/[^/]+\/account\/search$/,
      index: 137
    },
    {
      re: /^site\/device\/[^/]+\/[^/]+\/account$/,
      index: 138
    },
    {
      re: /^site\/c2b\/transfer\/[^/]+\/name\/history$/,
      index: 139
    },
    {
      re: /^site\/c2b\/transfer\/[^/]+\/portal\/domain$/,
      index: 140
    },
    {
      re: /^site\/c2b\/transfer\/[^/]+\/apply\/history$/,
      index: 142
    },
    {
      re: /^site\/c2b\/transfer\/[^/]+\/device\/exist$/,
      index: 143
    },
    {
      re: /^site\/device\/[^/]+\/domain\/[^/]+\/add$/,
      index: 150
    },
    {
      re: /^site\/device\/[^/]+\/domain\/[^/]+\/update$/,
      index: 151
    },
    {
      re: /^site\/device\/[^/]+\/domain\/[^/]+\/import$/,
      index: 152
    },
    {
      re: /^site\/device\/[^/]+\/cloud\/operate$/,
      index: 153
    },
    {
      re: /^site\/device\/[^/]+\/domain\/delete$/,
      index: 161
    },
    {
      re: /^site\/storage\/[^/]+\/box\/package\/info$/,
      index: 163
    },
    {
      re: /^site\/storage\/[^/]+\/box\/cap\/activation$/,
      index: 164
    },
    {
      re: /^site\/operations\/package\/[^/]+\/device\/add$/,
      index: 172
    },
    {
      re: /^site\/operations\/package\/[^/]+\/capacity\/info$/,
      index: 173
    },
    {
      re: /^site\/operations\/package\/[^/]+\/capacity\/sites$/,
      index: 174
    },
    {
      re: /^site\/operations\/package\/[^/]+\/capacity\/auto$/,
      index: 175
    },
    {
      re: /^site\/device\/[^/]+\/tenant\/delete$/,
      index: 187
    },
    {
      re: /^site\/[^/]+\/cloud\/enable$/,
      index: 188
    },
    {
      re: /^site\/device\/[^/]+\/[^/]+\/[^/]+\/disable$/,
      index: 194
    },
    {
      re: /^site\/measure\/probation\/[^/]+\/active$/,
      index: 214
    },
    {
      re: /^site\/measure\/probation\/[^/]+\/get$/,
      index: 215
    },
    {
      re: /^site\/device\/[^/]+\/measure\/devices\/list$/,
      index: 216
    },
    {
      re: /^site\/device\/[^/]+\/measure\/channels\/list$/,
      index: 217
    },
    {
      re: /^site\/device\/[^/]+\/measure\/channels\/open\/list$/,
      index: 218
    },
    {
      re: /^site\/[^/]+\/[^/]+$/,
      index: 70
    },
    {
      re: /^site\/operations\/[^/]+\/devices\/diagnosi\/export\/pdf$/,
      index: 235
    },
    {
      re: /^site\/storage\/[^/]+\/cloud\/package\/active$/,
      index: 241
    },
    {
      re: /^site\/storage\/[^/]+\/cloud\/trial\/active$/,
      index: 241
    },
    {
      re: /^site\/share\/[^/]+\/[^/]+\/cancel$/,
      index: 248
    }
  ],
  arc: [
    {
      re: /^arc\/[^/]+\/arc\/list$/,
      index: 144
    },
    {
      re: /^arc\/[^/]+\/relevance\/add$/,
      index: 145
    },
    {
      re: /^arc\/[^/]+\/relevance\/remove$/,
      index: 146
    },
    {
      re: /^arc\/[^/]+\/site\/relevance\/add$/,
      index: 147
    },
    {
      re: /^arc\/[^/]+\/site\/relevance\/remove$/,
      index: 148
    },
    {
      re: /^arc\/[^/]+\/site\/relevance\/query$/,
      index: 149
    }
  ],
  vca: [
    {
      re: /^vca\/[^/]+\/thermalcamera\/channel\/config$/,
      index: 221
    },
    {
      re: /^vca\/[^/]+\/thermalcamera\/channel\/paraminfo$/,
      index: 222
    },
    {
      re: /^vca\/[^/]+\/thermalcamera\/temperaturescreening$/,
      index: 223
    },
    {
      re: /^vca\/[^/]+\/peoplecounting\/groups\/add$/,
      index: 226
    },
    {
      re: /^vca\/[^/]+\/peoplecounting\/groups\/modify$/,
      index: 227
    },
    {
      re: /^vca\/[^/]+\/peoplecounting\/groups\/delete$/,
      index: 228
    },
    {
      re: /^vca\/[^/]+\/peoplecounting\/groups\/get\/[^/]+$/,
      index: 229
    }
  ]
};

const removeCharBothsides = function(url, char = '/') {
  if (url[0] === char) {
    url = url.slice(1);
  }
  if (url[url.length - 1] === char) {
    url = url.slice(0, url.length - 1);
  }
  return url;
};
export const getUrlPrefixTip = function(url, method) {
  url = removeCharBothsides(url);
  const firstWord = url.slice(0, url.indexOf('/'));
  const urlList = URL_TIP_MAP[firstWord];
  let result = '';
  if (!urlList) {
    return result;
  }
  for (let item of urlList) {
    if (item.re.test(url)) {
      if ('method' in item) {
        if (!method) {
          // eslint-disable-next-line no-console
          console.error(`url: [${url}] 需要传入请求动作，例如: post get`);
          break;
        }
        if (method && method.toLowerCase() === item.method) {
          result = i18n.t(`error_tip_prefix_${item.index}_${item.method.toLowerCase()}`);
          break;
        }
      } else {
        result = i18n.t(`error_tip_prefix_${ item.index}`);
        break;
      }
    }
  }
  return result;
};
